import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import TypeSelector from "../components/Form/TypeSelector.jsx";
import UserProfile from "../components/Profile/UserProfile.jsx";
import DetalleProyecto from "../components/Proyectos/DetalleProyecto";
import MyProjects from "../components/Proyectos/MyProjects";
import { TablaSeguimientoPlanificaciones } from "../components/Proyectos/TablaSeguimientoPlanificaciones";
import SandBox from "../components/SandBox/SandBox.jsx";
import { useAuthContext } from "../hooks/Auth";
import MainProviders from "../layout/MainProviders";
import HomePage from "../pages/HomePage";
import LoadingPage from "../pages/LoadingPage.tsx";
import { ReportesPage } from "../pages/ReportesPage.tsx";
import { superAdminRoutes } from "./RouteLists/SuperAdminRoutes.tsx";
import { useEffect } from "react";

const ProtectedRoutes = () => {
  const { user, isUserAuthenticated, canAccess } = useAuthContext();
  const { pathname } = useLocation();

  //Con este snippet aseguramos que al entrar a una ruta nueva, vaya a arriba
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  if (!user || !isUserAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <MainProviders>
      <Routes>
        {/**Ruta para menú de inicio*/}
        <Route path={"menu"} element={<HomePage />} />
        {/**Ruta para el selector de tipo de planificación */}
        <Route path={"typeselector"} element={<TypeSelector />} />

        {/**UMMIAPPS */}
        {user.ummiapps.map((app) => {
          return (
            <Route
              key={app.id_componente}
              path={app.route}
              element={app.elemento}
            />
          );
        })}

        {/**CATEGORÍAS DE APPS */}
        {user.categories.map((route) => {
          return (
            <Route
              key={route.label}
              path={route.route}
              element={route.elemento}
            />
          );
        })}

        {/**Ruta para mis proyectos */}
        <Route path={"myprojects"} element={<MyProjects />} />
        {/* Dettale de proyecto */}
        <Route path="detalleproyecto/:id" element={<DetalleProyecto />} />
        {/**Ruta para mis planificaciones en proceso */}
        <Route
          path={"myplaninginprocess"}
          element={<TablaSeguimientoPlanificaciones />}
        />
        {/**Ruta para pagina de carga */}
        <Route path={"process"} element={<LoadingPage />} />

        {/**Ruta para reportes */}
        <Route path={"reportes"} element={<ReportesPage />} />

        {/**Ruta para Perfil de usuario */}
        <Route path={"userprofile"} element={<UserProfile />} />
        {/**Ruta para SandBox */}
        <Route path={"sandbox"} element={<SandBox />} />

        {/**PERFIL ADMINISTRADOR */}
        {superAdminRoutes
          .filter((route) => canAccess(route.permission)) // Filtramos por las que tengan permiso
          .map((route) => (
            <Route key={route.path} path={route.path} element={route.element}>
              {route.children &&
                route.children
                  .filter((child) => canAccess(child.permission)) // Filtramos por las que tengan permiso
                  .map((child) => (
                    <Route
                      key={child.path}
                      path={child.path}
                      element={child.element}
                    />
                  ))}
            </Route>
          ))}

        {/* Otras rutas o redireccionar al menu si no se encuentra una ruta */}
        <Route path="*" element={<Navigate to="menu" replace />} />
      </Routes>
    </MainProviders>
  );
};

export default ProtectedRoutes;
